import {
  JOB_OUTCOMES,
  type JobOutcomeType,
} from '@/features/jobs/lib/job-outcome-options'

const jobOutcomeTypeLabels: Record<JobOutcomeType, string> = Object.fromEntries(
  JOB_OUTCOMES.map((outcome) => [outcome.value, outcome.label])
) as Record<JobOutcomeType, string>

export const formatJobOutcomeType = (outcome: JobOutcomeType) =>
  jobOutcomeTypeLabels[outcome]
